export class PlatformService {
    platform:string='';
    iphoneX:boolean=false;
}


// WEBPACK FOOTER //
// ./src/services/platform.ts